import LandingPageFeatures from '@/app/components/LandingPage/LandingPageFeatures';

import activityAndMovementFeaturesData from '../_data/activityAndMovementFeaturesData';
import activityAndMovementFeaturesGradients from '../_data/activityAndMovementFeaturesGradients';

const ActivityAndMovementFeatures = () => {
  return (
    <section className="py-20" data-cy="activity-and-movement-features">
      <LandingPageFeatures
        className="z-10"
        eyebrow="activity_features_eyebrow"
        features={activityAndMovementFeaturesData}
        theme="dark"
        imageGradientBg={{
          className: 'bg-orange-300',
          gradients: activityAndMovementFeaturesGradients,
        }}
        textColor="brown-600"
      />
    </section>
  );
};

export default ActivityAndMovementFeatures;
